import { render, staticRenderFns } from "./FreelancerProfile.htm?vue&type=template&id=9c2a33c8&scoped=true&"
import script from "./FreelancerProfile.ts?vue&type=script&lang=js&"
export * from "./FreelancerProfile.ts?vue&type=script&lang=js&"
import style0 from "./FreelancerProfile.scss?vue&type=style&index=0&id=9c2a33c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2a33c8",
  null
  
)

export default component.exports